import React, { useState, useEffect } from "react";
import Input from "../../../../UI/Input/Input";
import { connect } from "react-redux";
import ImpactedMemberTable from "../../../../UI/DataTable/DataTable";
import QuickSearchModal from "../../../Search/SearchWindow/QuickSearch/QuickSearchModal/QuickSearchModal";
import {
  ALLOWED_INCIDENT_RECORD_NUMBER,
  HSID_PERSONAL_REPRESENTATIVE,
  SESSION_SUPERUSER,
  SESSION_TIER1USER,
} from "../../../../shared/Constants";
import { getLastLoginDate } from "../../QuickView/QuickView";
import { getPortalNameForEligibilityScreen } from "../../../../shared/utility";
import Moment from "moment";
import classes from "./ImpactedMember.css";
import { useParams } from "react-router";
import Spinner from "../../../../UI/Spinner/Spinner";
import EnableMemberModal from "../EnableMemberModal/EnableMemberModal";
import EnableDisableModal from "../EnableDisableModal/EnableDisableModal";
import ReactTooltip from "react-tooltip";
import * as actions from "../../../../store/actions";
import Button from "../../../../UI/Button/Button";

const ImpactedMember = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showEnableModal, setShowEnableModal] = useState(false);
  const params = useParams();
  let idType = params?.idType;
  let isIdTypePR = idType === HSID_PERSONAL_REPRESENTATIVE;
  const [impactedMemberList, setImpactedMemberList] = useState([]);
  const [addClicked, setAddClicked] = useState(false);
  const [checkedUuid, setCheckedUuid] = useState(null);
  const [checkedUsername, setCheckedUsername] = useState(null);
  const [check, setCheck] = useState();

  let resultColumnMapping = [
    {
      dataField: "enableAccount",
      checkbox: {
        selectRow: true,
      },
    },
    // { dataField: "date", text: "Date/ Time" },
    // { dataField: "agentId", text: "MSID" },
    { dataField: "delete", text: "" },
    { dataField: "priImpactedFlag", text: "Primary/ Impacted" },
    { dataField: "firstName", text: "First Name" },
    { dataField: "lastName", text: "Last Name" },
    { dataField: "sourceCd", text: "ID Type" },
    { dataField: "memberId", text: "Member/ Subscriber ID" },
    { dataField: "hsidCreatedDate", text: "HSID Created Date" },
    { dataField: "dob", text: "Date Of Birth" },
    { dataField: "zip", text: "Zip Code" },
    { dataField: "recoveryMethod", text: "Recovery Method" },
    { dataField: "lastLoginDate", text: "HSID Last Login Date" },
    { dataField: "pwdResetDate", text: "HSID Password Reset Date" },
    { dataField: "hsidRegistrationPortal", text: "HSID Registration Portal" },
    { dataField: "uuid", text: "UUID" },
  ];

  const addImpactedMember = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const toggleModalHandler = () => {
    setShowModal(!showModal);
  };
  const toggleEnableModalHandler = () => {
    setShowEnableModal(!showEnableModal);
  };

  const enableMember = (e) => {
    props.clearEnableDisableStatusMsg();
    e.preventDefault();
    setShowEnableModal(true);
  };

  const setImpactedTableDisabled = (mapRes) => {
    const tempImpactedLst = [];
    for (let key in props.incidentMembersList) {
      let uuid = props.incidentMembersList[key].healthSafeId
        ? props.incidentMembersList[key].healthSafeId
        : props.incidentMembersList[key].essoData.uuid;
      let value = uuid + " " + props.incidentMembersList[key].essoData.userName;
      const hlthSfId = props.isNullHSID
        ? ""
        : props.incidentMembersList[key].member[0].healthSafeId
        ? props.incidentMembersList[key].member[0].healthSafeId
        : props.incidentMembersList[key].essoData.uuid;

      if (
        mapRes[hlthSfId] &&
        mapRes[hlthSfId].memberType !== "PRIMARY" &&
        props.userType === SESSION_TIER1USER &&
        mapRes[hlthSfId].createdBy !== props.agentDetails.userLoginId
      ) {
        continue;
      }

      tempImpactedLst.push({
        id: key,
        enableAccount: mapRes[hlthSfId] ? (
          checkedUuid === uuid ? (
            <Input
              elementType={"checkbox"}
              id={key}
              value={value}
              checked={true}
              changed={handleChange}
            ></Input>
          ) : (
            <Input
              elementType={"checkbox"}
              id={key}
              value={value}
              checked={false}
              changed={handleChange}
            ></Input>
          )
        ) : null,
        delete: (
          <a data-tip data-for="callerDetails" onClick={()=>removeImpactedMember(key)}>
          <span className="fa fa-trash"></span>{" "}
        </a>
        ),
        date: mapRes[hlthSfId]?.createdTs,
        agentId: mapRes[hlthSfId]?.createdBy,

        priImpactedFlag: mapRes[hlthSfId]?.memberType
          ? mapRes[hlthSfId]?.memberType
          : props.incidentMembersList[key]?.priImpactedFlag
          ? props.incidentMembersList[key]?.priImpactedFlag
          : "",
        firstName: props.isNullHSID
          ? props.incidentMembersList[key].member[0].mdmFirstNm
          : props.incidentMembersList[key].essoData.firstName,
        lastName: props.isNullHSID
          ? props.incidentMembersList[key].member[0].mdmLastNm
          : props.incidentMembersList[key].essoData.lastName,
        sourceCd: props.incidentMembersList[key]?.idType,
        memberId: props.incidentMembersList[key].member[0].mdmSubscriberId,
        hsidCreatedDate: props.incidentMembersList[key].member[0]
          .createTimestamp
          ? Moment(
              props.incidentMembersList[key].member[0].createTimestamp
            ).format("YYYY-MM-DD")
          : "",
        dob: props.incidentMembersList[key].member[0].mdmDob
          ? props.incidentMembersList[key].member[0].mdmDob
          : props.incidentMembersList[key].essoData.dob,
        zip: props.incidentMembersList[key].member[0].mdmZip,
        recoveryMethod: props.isNullHSID
          ? ""
          : props.incidentMembersList[key].essoData?.phone?.number
          ? "Phone"
          : "Security Questions",
        lastLoginDate:
          props.isNullHSID || isIdTypePR
            ? ""
            : getLastLoginDate(props.incidentMembersList[key]),
        pwdResetDate: "",
        hsidRegistrationPortal:
          props.incidentMembersList[key].member[0].mbrRgstPrtlShrtNm &&
          !isIdTypePR
            ? getPortalNameForEligibilityScreen(
                props.incidentMembersList[key].member[0].mbrRgstPrtlShrtNm
              )
            : "",
        uuid: hlthSfId,
      });
    }
    return tempImpactedLst;
  };
  const handleChange = (e) => {
    if (e.target.checked) {
      setCheckedUuid(e.target.value.split(" ")[0]);
      setCheckedUsername(e.target.value.split(" ")[1]);
    } else {
      setCheckedUuid(null);
      setCheckedUsername(null);
    }
  };

  const removeImpactedMember=(key)=>{
    const list = [...props.incidentMembersList];
    list.splice(key, 1);
    props.resetIncidentMembersList(list);
    setImpactedMemberList(setImpactedTable(list));
  }

  const setImpactedTable = () => {
    const tempImpactedLst = [];
    for (let key in props.incidentMembersList) {
      let uuid = props.incidentMembersList[key].healthSafeId
        ? props.incidentMembersList[key].healthSafeId
        : props.incidentMembersList[key].essoData.uuid;
      let value = uuid + " " + props.incidentMembersList[key].essoData.userName;
      tempImpactedLst.push({
        id: key,
        enableAccount: (
          <Input
            elementType={"checkbox"}
            id={key}
            value={value}
            changed={handleChange}
          ></Input>
        ),
        delete: (
          <a data-tip data-for="callerDetails" onClick={()=>removeImpactedMember(key)}>
          <span className="fa fa-trash"></span>{" "}
        </a>
        ),
        date: "",
        agentId: "",

        priImpactedFlag: props.incidentMembersList[key]?.priImpactedFlag,
        firstName: props.isNullHSID
          ? props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.mdmFirstNm
          : props.incidentMembersList[key]?.essoData?.firstName,
        lastName: props.isNullHSID
          ? props.incidentMembersList[key]?.member && props.incidentMembersList[key].member[0].mdmLastNm
          : props.incidentMembersList[key]?.essoData?.lastName,
        sourceCd: props.incidentMembersList[key]?.idType,
        memberId: props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.mdmSubscriberId,
        hsidCreatedDate: props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.createTimestamp
          ? Moment(
            props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.createTimestamp
            ).format("YYYY-MM-DD")
          : "",
        dob: props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.mdmDob
          ? props.incidentMembersList[key]?.member[0]?.mdmDob
          : props.incidentMembersList[key]?.essoData?.dob,
        zip: props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.mdmZip,
        recoveryMethod: props.isNullHSID
          ? ""
          : props.incidentMembersList[key]?.essoData?.phone?.number
          ? "Phone"
          : "Security Questions",
        lastLoginDate:
          props.isNullHSID || isIdTypePR
            ? ""
            : getLastLoginDate(props.incidentMembersList[key]),
        pwdResetDate: props.isNullHSID
          ? ""
          : props.incidentMembersList[key]?.essoData?.essoStatus?.lastPasswordChangeTime
          ? props.incidentMembersList[key]?.essoData?.essoStatus?.lastPasswordChangeTime
          : "",
        hsidRegistrationPortal: props.incidentMembersList[key]?.member && 
          props.incidentMembersList[key]?.member[0]?.mbrRgstPrtlShrtNm &&
          !isIdTypePR
            ? getPortalNameForEligibilityScreen(
              props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.mbrRgstPrtlShrtNm
              )
            : "",
        uuid: props.isNullHSID
          ? ""
          : props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.healthSafeId
          ? props.incidentMembersList[key]?.member && props.incidentMembersList[key]?.member[0]?.healthSafeId
          : props.incidentMembersList[key]?.essoData.uuid,
      });
    }
    return tempImpactedLst;
  };

  useEffect(() => {
    if (props.impactedMemberData) {
      const incidentActionMemberResList =
        props.impactedMemberData.incidentMemberActionResponses;
      const incidentActionMemberResMap = {};
      incidentActionMemberResList.forEach((element) => {
        incidentActionMemberResMap[element.healthSafeId] = element;
      });
      setImpactedMemberList(
        setImpactedTableDisabled(incidentActionMemberResMap)
      );
    } else {
      setImpactedMemberList(setImpactedTable(props.incidentMembersList));
    }
    setAddClicked(false);
  }, [props.incidentMembersList, checkedUuid, props.userType]);

  const modalBasicSearch = showModal ? (
    <EnableDisableModal show={showModal} modalClosed={toggleModalHandler}>
      <QuickSearchModal
        quickSearch
        headerHandler=""
        closeModal={toggleModalHandler}
        setAddClicked={setAddClicked}
      ></QuickSearchModal>
    </EnableDisableModal>
  ) : null;

  const enableMemberModal = showEnableModal ? (
    <EnableDisableModal
      show={showEnableModal}
      modalClosed={toggleEnableModalHandler}
    >
      <EnableMemberModal
        headerHandler=""
        closeModal={toggleEnableModalHandler}
        uuid={checkedUuid}
        username={checkedUsername}
      ></EnableMemberModal>
    </EnableDisableModal>
  ) : null;

  if (props.impactedMemberData) {
    resultColumnMapping = resultColumnMapping.filter(
      (mapping) => mapping.dataField !== "lastLoginDate"
    );
  } else {
    resultColumnMapping = resultColumnMapping.filter(
      (mapping) => mapping.dataField !== "enableAccount"
    );
  }

  const addImpactedMemberDisabled = () => {
    if (props.incidentMembersList?.length === ALLOWED_INCIDENT_RECORD_NUMBER)
      return true;
    if (props.impactedMemberData) {
      const responseLst =
        props.impactedMemberData.incidentMemberActionResponses;
      for (let key = 0; key < responseLst.length; key++) {
        const element = responseLst[key];
        if (
          element.memberType === "PRIMARY" &&
          props.userType === SESSION_TIER1USER &&
          element.createdBy !== props.agentDetails.userLoginId
        ) {
          return true;
        }
      }
    }
    // return false || props.formType === "details";
    return false || props.formDisabled;
  };

  return (
    <>
      {modalBasicSearch}
      {enableMemberModal}
      {!props.isSameSection && (
        <div className={classes.FormTitle}>
          {"Impacted Members"}
          &nbsp;
          <a data-tip data-for="impactedMembers">
            <span className="fa fa-question-circle"></span>{" "}
          </a>
          <ReactTooltip id="impactedMembers">
            <span>
              Add details of members impacted because of this incident
            </span>
          </ReactTooltip>
        </div>
      )}
      <div className={!props.isSameSection && classes.box}>
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <Button
            disabled={addImpactedMemberDisabled()}
            className={classes.copy_button}
            clicked={addImpactedMember}
            btnType="Search"
          >
            Search Member
          </Button>
          {/* <button className={classes.copy_button} onClick={enableMember} disabled={(checkedUuid === null)||(props.userType !== SESSION_SUPERUSER)}>
              Enable
            </button> */}
        </div>
        {impactedMemberList && impactedMemberList.length > 0 && (
          <div style={{ overflowX: "auto" }}>
            <ImpactedMemberTable
              title=""
              data={impactedMemberList}
              columns={resultColumnMapping}
              clicked={(data) => {
                return false;
              }}
              extendXScroll={true}
            />
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          {addClicked ? <Spinner /> : null}
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    impactedMemberData: state.member.impactedMemberData,
    incidentMembersList: state.member.incidentMembersList,
    memberData: state.member.member,
    agentDetails: state.usr.user,
    formType: state.serviceNow.formType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearEnableDisableStatusMsg: () =>
      dispatch(actions.clearEnableDisableStatusMsg()),
    resetIncidentMembersList: (data) => dispatch(actions.resetIncidentMembersList(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImpactedMember);
